import React from 'react';
import { TextField } from '@wix/wix-ui-tpa/cssVars';
import { setAddNewFolderMoveObservable } from '../../Services/Move/Move.service';
import { startMoving } from '../../Services/Move/MovingProccess';
import { st, classes } from './MoveWrapper.st.css';
import { setMoveLoader } from '../../Services/ItemsMove.service';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useAppContext } from '../AppContext';

const MoveAddNewFolderOutSideClick = (props: any) => {
  const { moveAddFolderFolderName, moveAddFolderFolderStatus, isMobile } =
    props;
  const { t } = useTranslation();
  const { compId } = useAppContext();
  return (
    <>
      <TextField
        className={st(classes.addMoveFolder, { isMobile })}
        autoFocus
        placeholder={t('app.widget.move.createNewFolder.input.placeHolder')}
        onBlur={() => {
          setTimeout(() => {
            if (
              moveAddFolderFolderName !== '' &&
              moveAddFolderFolderStatus === true
            ) {
              startMoving(compId);
            }
          }, 4000);
          if (
            moveAddFolderFolderName !== '' &&
            moveAddFolderFolderStatus === true
          ) {
            setTimeout(() => {
              setMoveLoader(true);
            }, 500);
          }
        }}
        onChange={(e: any) => {
          setAddNewFolderMoveObservable({
            status: true,
            folderName: e.target.value,
          });
        }}
      />
    </>
  );
};

export default MoveAddNewFolderOutSideClick;
